import styled from 'styled-components';
import { spacingInRems } from '../themeUtils';

export default styled.div`
  && {
    display: flex;
    flex-direction: column;
    align-items: center;
    &.hidden {
      opacity: 0;
      pointer-events: none;
    }
    .amount {
      font-size: 4.2rem;
      line-height: 6rem;
      font-weight: 500;
      color: #000000;
    }
    .balanceOutOfPlan {
      margin-top: 1rem;
      strong {
        margin-left: 0.5rem;
      }
    }
    .buttonContainer {
      width: 100%;
      .button {
        width: 100%;
        font-size: 1.8rem;
        padding-left: 1rem;
        padding-right: 1rem;
        margin-top: 2rem;
        .text {
          display: flex;
          align-items: center;
          svg {
            color: #fff;
          }
        }
      }
    }
    .selectBillTotal {
      margin-top: ${spacingInRems()};
    }
  }
`;
